import { useEffect } from "react";

// Lightweight SEO head manager (no external deps).
export default function Seo({ page, fallback }) {
  useEffect(() => {
    let active = true;
    const apply = (s) => {
      if (!active || !s) return;
      document.title = s.title || fallback?.title || "WebLaunch Studio";
      setMeta("name", "description", s.meta_description);
      setMeta("property", "og:title", s.og_title || s.title);
      setMeta("property", "og:description", s.og_description || s.meta_description);
      if (s.og_image) setMeta("property", "og:image", s.og_image);
      setLink("canonical", (window.location.origin + (s.canonical || "")).replace(/\/$/, "") || window.location.origin);
    };
    if (fallback) apply(fallback);
    if (page) {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/seo/${page}`)
        .then((r) => (r.ok ? r.json() : null))
        .then((s) => s && apply(s))
        .catch(() => {});
    }
    return () => { active = false; };
  }, [page, fallback]);
  return null;
}

function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}
